import { Component, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PopupService } from '../..//core/services/popup/popup.service';
import { FormService } from '../../shared/services/form/form.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { LoginService } from '../../features/login/login.service';
import { mailInfo } from '../../types/mailInfo';
import { JwtService } from '../../shared/services/jwt/jwt.service';
import { MailService } from '../../core/services/mail/mail.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.sass'],
    standalone: false
})

export class ContactComponent {

  contactForm: FormGroup;
  contactAdmin = false;
  mailObject: mailInfo = new mailInfo();
  showEmailResponse = '';
  userDetails: any;
  email: string = '';

  constructor(private popupService: PopupService, private fb: FormBuilder, private formService: FormService,
              private authService: AuthService, private loginService: LoginService, private jwtService: JwtService,
              private mailService: MailService, public translate: TranslateService) {
    this.contactForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/))])],
      message: ['', Validators.compose([Validators.required, Validators.minLength(10)])]
    });
    if(this.isAuthenticated()) {
      effect(() => {
        this.userDetails = this.loginService.gigyaResponse;  
        this.email = this.userDetails.userMail;       
      });
    }
  }

  ngOnInit() { }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  closePopup() {
    this.popupService.closeCurrentDialog();
  }

  getErrorMessage(controlName: string): string {
    return this.contactForm.get(controlName)?.touched ? this.formService.getErrorMessageForFormControl(controlName, this.contactForm) : '';
  }

  submitForm() {
    if(this.contactForm.valid) {
      // Handle form submission logic here
      if(!environment.production) {
        console.log('Form submitted:', this.contactForm.value);
      }
      this.mailToAdmin();
    } else {
      this.contactForm.markAllAsTouched();
    }
  }

  mailToAdmin() {
    if(this.isAuthenticated()) {
      this.mailObject.messageHead = 'End user queries / concerns ';
      this.mailObject.subject = 'ASOM – Registered user issue (' + this.userDetails.firstName + ' ' + this.userDetails.lastName +' )';
      this.mailObject.username = this.userDetails.firstName + ' ' + this.userDetails.lastName;
      this.mailObject.mobileNumber = this.userDetails.mobileNumber;
    } else {
      this.mailObject.messageHead = 'End user queries / concerns';
      this.mailObject.subject = 'ASOM – Pre Registration issue (' + this.contactForm.value.email + ')';
      this.mailObject.mobileNumber = '-';
      this.mailObject.username = '-';
    }
    this.mailObject.fromAddress = this.contactForm.value.email;
    this.mailObject.message = this.contactForm.value.message;
    this.mailObject.error = false;
    this.mailObject.errorMessage = '';
    let mailData: string = this.jwtService.encode(this.mailObject, "secret");   
    this.mailService.mailToAdmin(mailData).subscribe((response: any) => {
      if(response && !response.error) {
        this.popupService.openDialog(MessagePopupComponent, {
          data: { message: this.translate.instant("EMAIL_SUCCESSFUL") }
        });
      } else {
        this.popupService.openDialog(MessagePopupComponent, {
          data: { message: this.translate.instant("EMAIL_FAILURE") }
        });
      }
    });
  }

}